import { render } from "./MetodosDePago.vue?vue&type=template&id=56d169c9"
import script from "./MetodosDePago.vue?vue&type=script&lang=js"
export * from "./MetodosDePago.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__